<template>
  <de-layout-content>
    <div class="">
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="ant-advanced-search-form">
        <el-form-item label="行政省份">
          <el-select v-model="searchForm.createBy" placeholder="请选择省份">
            <el-option :label="item.label" :value="item.value" :key="index"
              v-for="(item, index) in createByList"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属城市">
          <el-select v-model="searchForm.createBy" placeholder="请选择城市">
            <el-option :label="item.label" :value="item.value" :key="index"
              v-for="(item, index) in createByList"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.type" placeholder="请选择状态">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('searchForm')">查询</el-button>
          <el-button type="" @click="resetForm('searchForm')" icon="el-icon-refresh">重置</el-button>
          <el-button type="primary" @click="addAction" icon="el-icon-check">新增省份</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据列表 -->
    <div class="">
      <el-table v-loading="loading" :data="tableData" row-key="id" class="mt20" :default-expand-all="isExpandAll"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column prop="name" label="行政区域" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="icon" label="组织数量" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.hidden" :active-value="false" :inactive-value="true" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" min-width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd(scope.row)">新增
            </el-button>
            <el-button size="mini" type="success" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改
            </el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="">
      <el-dialog title="新增城市" :visible.sync="dialogFormVisible">
        <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" style="width: 100%">
          <el-form-item label="所属省份" prop="region">
            <el-select v-model="formData.region" placeholder="请选择活动区域" style="width: 100%">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市" prop="region">
            <el-select v-model="formData.region" placeholder="请选择活动区域" style="width: 100%">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市">
            <el-radio-group v-model="formData.radio">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </de-layout-content>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      isExpandAll: false,
      dialogFormVisible: false,
      searchForm: {},
      formData: {},
      createByList: [],
      tableData: [
        {
          id: 1,
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          id: 2,
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          id: 3,
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
          children: [
            {
              id: 31,
              date: "2016-05-01",
              name: "王小虎",
              address: "上海市普陀区金沙江路 1519 弄",
            },
            {
              id: 32,
              date: "2016-05-01",
              name: "王小虎",
              address: "上海市普陀区金沙江路 1519 弄",
            },
          ],
        },
        {
          id: 4,
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
      rules: {
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    addAction() {
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleAdd(row) {
      console.log(row);
    },
    handleUpdate(row) {
      console.log(row);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
